<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="mt-2 col-md-12"></div>

    <div class="bodyNuevaHistoria">
      <md-toolbar class="md-primary">
        <h3 class="md-title">Sección 1.Detección de Necesidades:</h3>
      </md-toolbar>
    </div>

    <div class="divFlexStart">
      <md-switch
        v-model="seccionUno.sonrisa"
        :value="1"
        class="md-primary divItemUno"
        >¿Te gusta tu sonrisa?</md-switch
      >
    </div>

    <div class="divFlexStart">
      <md-field class="divItemUno">
        <label>En caso de responder que si, ¿Por qué no?</label>
        <md-input v-model="seccionUno.respuesta"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <p class="boldBlue size22">Blanqueamiento</p>
    </div>

    <div class="divFlexStart">
      <md-switch
        v-model="seccionUno.producto"
        :value="1"
        class="md-primary divItemUno"
      >
        ¿Alguna vez haz utilizado algun sistema o producto de blanqueamiento en
        tus dientes?
      </md-switch>
    </div>

    <div class="divFlexStart">
      <p>En caso de responder que sí. ¿Qué sistema/producto utilizaste?</p>
    </div>

    <div class="divFlexStart">
      <md-radio v-model="seccionUno.pastaDental" :value="1" class="md-primary"
        >Pasta dental con blanqueamiento.</md-radio
      >
    </div>

    <div class="divFlexStart">
      <md-radio
        v-model="seccionUno.blanqueamiento"
        :value="1"
        class="md-primary divItemDos"
        >Blanqueamiento en una clínica dental.</md-radio
      >
      <md-field class="divItemDos">
        <label>Detallar características.</label>
        <md-input v-model="seccionUno.detalleBla"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <md-radio
        v-model="seccionUno.blanqueamientoCasa"
        :value="1"
        class="md-primary divItemDos"
        >Blanqueamiento en casa.</md-radio
      >
      <md-field class="divItemDos">
        <label>Detallar características.</label>
        <md-input v-model="seccionUno.detallarCaractB"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <md-radio
        v-model="seccionUno.otro"
        :value="1"
        class="md-primary divItemDos"
        >Otro.</md-radio
      >
      <md-field class="divItemDos">
        <label>Especificar</label>
        <md-input v-model="seccionUno.especificar"></md-input>
      </md-field>
    </div>

    <p>
      En una escala del 0 al 10 donde 0 es no recomendaría y 10 es
      definitivamente recomendaría, ¿qué tanto recomendarías el sistema/producto
      de blanqueamiento utilizado?
    </p>

    <div class="divFlexStart">
      <md-field class="divItemDos">
        <label>Numero</label>
        <md-input v-model="seccionUno.numero" type="number"></md-input>
      </md-field>
      <md-field class="divItemDos">
        <label>¿Porque?</label>
        <md-input v-model="seccionUno.porque"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <p class="boldBlue size22">Ortodoncia</p>
    </div>

    <div class="divFlexStart">
      <md-switch v-model="seccionUno.ortodoncia" :value="1" class="md-primary"
        >¿Alguna vez has utilizado algún tratamiento de Ortodoncia ?</md-switch
      >
    </div>

    <div class="divFlexStart">
      <p>
        En caso de responder que si. ¿Qué tratamiento de Ortodoncia utilizaste?
      </p>
    </div>

    <div class="divFlexStart">
      <md-field class="divItemUno">
        <label>Brackets ¿Cuáles?</label>
        <md-input v-model="seccionUno.brackets"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <md-field class="divItemUno">
        <label>Alineadores ¿Cuáles?</label>
        <md-input v-model="seccionUno.alineadores"></md-input>
      </md-field>
    </div>

    <div class="divFlexStart">
      <md-switch
        v-model="seccionUno.volveriasOrtodoncia"
        :value="1"
        class="md-primary divItemUno"
        >¿Volverías a utilizar Ortodoncia?</md-switch
      >
    </div>

    <div class="divFlexStart">
      <md-field class="divItemUno">
        <label>En caso de responder no. ¿Por qué no?</label>
        <md-input v-model="seccionUno.ortodonciaNo"></md-input>
      </md-field>
    </div>

    <md-toolbar class="md-primary">
      <h3 class="md-title">
        Sección 2.Preclasificación del paciente con base en tu percepción:
      </h3>
    </md-toolbar>

    <div class="divFlexStart">
      <p class="mginTop15">
        Con base a la plática previa que tuviste con el paciente de necesidades
        y/o dudas, llena las siguientes afirmaciones, puedes marcar más de una
        casilla.
      </p>
    </div>

    <div class="divFlexStart">
      <p>
        Selecciona los motivadores de consulta por los que viene el paciente:
      </p>
    </div>

    <div class="divFlexStart">
      <md-radio v-model="seccionDos.dolor" :value="1" class="md-primary"
        >Dolor-molestia</md-radio
      >
      <md-radio v-model="seccionDos.prevencion" :value="1" class="md-primary"
        >Prevención-Salud</md-radio
      >
      <md-radio v-model="seccionDos.estetica" :value="1" class="md-primary"
        >Estética</md-radio
      >
    </div>

    <div class="divFlexStart">
      <p class="divItemUno">
        Selecciona el enfoque de conversación con el paciente:
      </p>
    </div>

    <div class="FlexWrap">
      <md-radio v-model="seccionDos.tiempos" :value="1" class="md-primary"
        >Tiempos</md-radio
      >
      <md-radio v-model="seccionDos.precios" :value="1" class="md-primary"
        >Precios</md-radio
      >
      <md-radio v-model="seccionDos.experiencia" :value="1" class="md-primary"
        >Experiencia del Odóntologo</md-radio
      >
      <md-radio v-model="seccionDos.resultados" :value="1" class="md-primary"
        >Resultados</md-radio
      >
      <md-radio v-model="seccionDos.onsecuencias" :value="1" class="md-primary"
        >Consecuencias-Riesgos</md-radio
      >
      <md-radio v-model="seccionDos.dolorDurante" :value="1" class="md-primary"
        >Dolor durante y después del tratamiento</md-radio
      >
    </div>

    <div class="divFlexStart alignUnset">
      <md-card class="divItemUno flexCenter">
        <md-card-content>
          <div class="divFlexStart alignUnset">
            <md-field class="divItemDos">
              <md-icon class="fa fa-user"></md-icon>
              <label>Usuario</label>
              <md-input v-model="user.usuario"></md-input>
            </md-field>
            <md-field class="divItemDos">
              <label>Contraseña</label>
              <md-input v-model="user.password" type="password"></md-input>
            </md-field>
          </div>
          <md-button class="md-raised md-primary">Enviar</md-button>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>
<script>
export default {
  name: "needsDetection",
  components: {},
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    seccionUno: {
      sonrisa: null,
      respuesta: null,
      producto: null,
      pastaDental: null,
      blanqueamiento: null,
      detalleBla: null,
      blanqueamientoCasa: null,
      detallarCaractB: null,
      otro: null,
      especificar: null,
      numero: null,
      porque: null,
      ortodoncia: null,
      brackets: null,
      alineadores: null,
      volveriasOrtodoncia: null,
      ortodonciaNo: null
    },
    seccionDos: {
      dolor: null,
      prevencion: null,
      estetica: null,
      tiempos: null,
      precios: null,
      experiencia: null,
      resultados: null,
      onsecuencias: null,
      dolorDurante: null
    },
    user: {
      usuario: null,
      password: null
    }
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {}
};
</script>

<style scoped></style>
